import type { CommonProps } from '@/types/common';

import useStyles from './MainContent.styles';

function MainContent({ children }: CommonProps) {
  const { classes } = useStyles();

  return <main className={classes.mainContent}>{children}</main>;
}

export default MainContent;
